import axios from "axios";

export const publicReserve = (data) => axios.post("/guest_reservation", data);
